// Suivi des erreurs : en premier, pour voir aussi les erreurs de chargement.
import './sentry';
// Police de la charte KLY, servie avec le site (même rendu partout, réseau filtré compris).
import '@fontsource-variable/manrope';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
